import { type ActionArgs, assertEvent, assign } from 'xstate';

import { markBagFeaturedUpsellDismissed, markBagFeaturedUpsellShown } from '../../storage';
import { type BagFeaturedUpsellContext } from './bag-featured-upsell.machine.context';
import { type BagFeaturedUpsellEvent } from './bag-featured-upsell.machine.events';
import { type FeaturedUpsellProduct } from './bag-featured-upsell.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const assignBag: Action = assign(({ event }) => {
  assertEvent(event, 'BAG_READY');

  return {
    sessionInterval: event.sessionInterval,
    restaurantId: event.restaurantId,
    orderChannel: event.orderChannel,
    productLineageKey: event.productLineageKey,
    hasAnimationImage: event.hasAnimationImage,
    cartProductIds: event.cartProductIds,
    canShowUpsells: event.canShowUpsells,
    isReduceMotionEnabled: event.isReduceMotionEnabled,
  };
});

export const assignProduct: Action<AssignProductParams> = assign({
  product(_, params) {
    return params.product;
  },
});

export function markShown() {
  markBagFeaturedUpsellShown();
}

export function markDismissed() {
  markBagFeaturedUpsellDismissed();
}

// ─── External Actions ────────────────────────────────────────────────────────

export const trackView = noop;
export const trackAdd = noop;
export const trackDismiss = noop;
export const addProductToBag = noop;

// ─── Helpers ─────────────────────────────────────────────────────────────────

function noop() {}

// ─── Types ───────────────────────────────────────────────────────────────────

type Action<Params extends Record<string, unknown> | void = void> = (
  actionArgs: ActionArgs<BagFeaturedUpsellContext, BagFeaturedUpsellEvent, BagFeaturedUpsellEvent>,
  params: Params,
) => void;

type AssignProductParams = {
  product: FeaturedUpsellProduct | undefined;
};
